import { render } from "./MyOffersPage.vue?vue&type=template&id=efd16ff8&scoped=true"
import script from "./MyOffersPage.vue?vue&type=script&lang=js"
export * from "./MyOffersPage.vue?vue&type=script&lang=js"

import "./MyOffersPage.vue?vue&type=style&index=0&id=efd16ff8&lang=css"
import "./MyOffersPage.vue?vue&type=style&index=1&id=efd16ff8&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efd16ff8"]])

export default __exports__